import { LoginEmailRequest } from "@project/shared-types";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { v4 as uuidv4 } from "uuid";
import { useTokenLogin } from '../../../entities/user/hooks/useTokenLogin';
import { useUser } from "../../../entities/user/hooks/useUser";
import { sendMetrics } from "../../../shared/hooks/sendMetrics";
import { useLocalStorage } from "../../../shared/hooks/useLocalStorage";
import { LoginClientEmailAPI, LoginClientEmailCodeAPI } from "../model/login.model";

export const useLogin = () => {
  const [email, setEmail] = useLocalStorage("email", "");
  const [global_id] = useLocalStorage("global_id", uuidv4());
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [isCode, setIsCode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useTokenLogin()

  const handleEmailClick = async () => {
    try {
      setIsLoading(true);
      const data_featch = { email, global_id } as LoginEmailRequest;
      await LoginClientEmailAPI(data_featch);
      setIsCode(true);
      setIsLoading(false);
      sendMetrics("reachGoal", "new_auth_email");
    } catch (error) {
      sendMetrics("reachGoal", "error_email");
      console.error("login email error", error);
    }
  };

  const handleCodeClick = async ({ email, code }: { email: string; code: string }) => {
    try {
      sendMetrics("reachGoal", "new_auth_code");
      const data_featch = { email, code, global_id } as LoginEmailRequest;
      setIsLoading(true);
      const response = await LoginClientEmailCodeAPI(data_featch);
      if (response.error) {
        setError(response.error);
      }
      login(response.token, false);
      await new Promise((resolve) => setTimeout(resolve, 500));
      if (typeof window !== "undefined") {
        window.location.href = response.url;
      }
      setIsLoading(false);
    } catch (error) {
      sendMetrics("reachGoal", "error_code");
      console.error("login code error", error);
    }
  };

  const onKeyDownEmail = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleEmailClick();
    }
  };

  const onKeyDownCode = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleCodeClick({ email, code });
    }
  };

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const [emailHash, codeHash] = location.hash.split("=");
      if (emailHash && codeHash) {
        setEmail(emailHash.replace("#", ""));
        setCode(codeHash);
        handleCodeClick({ email: emailHash.replace("#", ""), code: codeHash });
      }
    }
  }, [location.hash]);

  const navigate = useNavigate();
  const user = useUser();
  useEffect(() => {
    if (user) {
      navigate(`/account/`);
    }
  }, [user]);

  return {
    email,
    setEmail,
    code,
    setCode,
    error,
    isCode,
    isLoading,
    onKeyDownEmail,
    onKeyDownCode,
    handleEmailClick,
    handleCodeClick,
  };
};
